import type { ModelGroups } from '../types'
import { modelsData } from './models'

// Model groups configuration
export const modelGroups: ModelGroups = {
  'Wkłady Dragon - Proste': 'dragon-proste',
  'Wkłady Dragon - Proste AKU': 'dragon-proste-aku',
  'Wkłady Dragon - Portal': 'dragon-portal',
  'Wkłady Dragon - Narożne': 'dragon-narozne',
  'Wkłady Dragon - Narożne AKU': 'dragon-narozne-aku',
  'Wkłady Dragon - Trójstronne': 'dragon-trojstronne',
  'Wkłady Dragon - Vis-a-vis': 'dragon-vis-a-vis',
  'Wkłady Dragon - Vis-a-vis AKU': 'dragon-vis-a-vis-aku',
  'Wkłady Dragon - Półokrągłe': 'dragon-polokragle',
  'Wkłady Nemo - Proste': 'nemo-proste',
  'Wkłady Nemo - Narożne': 'nemo-narozne',
  'Wkłady Nemo - Vis-a-vis': 'nemo-vis-a-vis'
}

// Export the combined models data
export { modelsData }

// Also export individual groups for convenience
export * from './models'
